export default __webpack_public_path__ + "static/media/select_device.33776236.png";